/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconPlaySolid from '@telus-uds/palette-allium/build/rn/icons/PlaySolid'
const theme = {
  appearances: {
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { hover: true },
      tokens: { buttonContentChildrenBackground: 'rgba(255, 255, 255, 0.8)' }
    }
  ],
  tokens: {
    buttonBackground: '#ffffff',
    buttonBorderColor: '#e3e6e8',
    buttonBottomPosition: 24,
    buttonContentBackground: 'rgba(0, 0, 0, 0.6)',
    buttonContentChildrenBackground: null,
    buttonLeftPosition: 24,
    buttonMinHeight: 64,
    buttonPaddingLeft: 16,
    buttonPaddingRight: 16,
    buttonRadius: 32,
    detailsContainerPadding: 8,
    labelFontName: 'HNforTELUSSA',
    labelFontWeight: '700',
    playIcon: PaletteIconPlaySolid,
    playIconColor: '#ffffff',
    playIconContainerBackground: '#2b8000'
  }
}
export default theme
